'use client';

import {
  Checkbox,
  Form,
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  InfoIconTooltip,
} from '@ais-ui/ui-core';
import { useLocalization } from '@ais-ui/locale-management';
import { UseFormReturn } from 'react-hook-form';
import { ShapeSelect } from '../../Shapes/ShapeSelects/ShapeSelect';
import { cn } from '@ais-ui/utils';
import { useMemo } from 'react';
import { NotificationsFormValues } from './useNotificationsForm';

interface NotificationsFormProps {
  form: UseFormReturn<NotificationsFormValues>;
}

export function NotificationsForm({ form }: NotificationsFormProps) {
  const { messages } = useLocalization();

  const emergencyAlerts = useMemo(
    () => form.watch('emergency_alerts_mdm'),
    [form.watch('emergency_alerts_mdm')]
  );

  return (
    <Form {...form}>
      <div className="space-y-8">
        <FormField
          key="emergency_alerts_mdm"
          control={form.control}
          name="emergency_alerts_mdm"
          render={({ field }) => (
            <FormItem className="space-y-3">
              <FormLabel>Notify me about...</FormLabel>
              <FormItem className="flex items-center space-x-3 space-y-0">
                <FormControl>
                  <div className="flex items-center space-x-2">
                    <Checkbox
                      id="emergency-alerts"
                      checked={field.value}
                      onCheckedChange={field.onChange}
                    />
                    <label
                      htmlFor="emergency-alerts"
                      className="text-sm font-normal leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                    >
                      Emergency alerts
                    </label>
                  </div>
                </FormControl>
              </FormItem>
              <FormMessage />
            </FormItem>
          )}
        />

        {emergencyAlerts && (
          <FormField
            key="emergency_area"
            control={form.control}
            name="emergency_area"
            render={({ field }) => (
              <FormItem
                className={cn(
                  'flex flex-row items-center justify-between border rounded-lg p-4'
                )}
              >
                <div className="space-y-0.5">
                  <div className="flex justify-between">
                    <FormLabel className="text-base">
                      {messages.settingsNotificationsEmergencyShapeLabel}
                    </FormLabel>
                    <InfoIconTooltip>
                      {messages.settingsNotificationsEmergencyShapeTooltip}
                    </InfoIconTooltip>
                  </div>

                  <FormDescription>
                    {messages.settingsNotificationsEmergencyShapeDescription}
                  </FormDescription>
                </div>
                <FormControl
                  id="settings-emergency-alerts-shape"
                  onChange={() => form.clearErrors()}
                >
                  <ShapeSelect
                    className="w-72"
                    id="emergency-alerts-shape-select"
                    value={field.value}
                    onChange={field.onChange}
                    allowedGeometryTypes={['Polygon']}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        )}
      </div>
    </Form>
  );
}
